module.exports = __webpack_public_path__ + "static/media/keyhole-square.feda077a.svg";